// src/components/ResponsiveSidebar.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTableColumns,
  faChildren,
  faAddressBook,
  faChalkboardTeacher,
  faFileInvoiceDollar,
  faUsers,
  faFileInvoice,
  faCalendarDay,
  faBoxArchive,
  faRightFromBracket,
  faReceipt,
  faBus,
  faMoneyBill,
  faBars,
  faTimes,
  faIdCard,
} from "@fortawesome/free-solid-svg-icons";
import brand from "../../images/hoop.png";
import { useAuth } from "../../context/AuthContext";

const ResponsiveSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { logout } = useAuth();

  const handleBackup = () => {
    window.location.href =
      "https://rm.connectifisolutions.com/rosemary_db/backup.php";
  };

  const handleLogout = () => {
    localStorage.removeItem("username");
    logout();
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Top Navigation Bar */}
      <div className="top-nav">
        <div className="nav-logo">
          <img src={brand} alt="Brand Logo" />
        </div>
        <button className="hamburger-menu" onClick={toggleSidebar}>
          <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
        </button>
      </div>

      {/* Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}

      {/* Responsive Sidebar */}
      <div className={`responsive-sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-content">
          <ul className="nav-list">
            <li>
              <NavLink className="nav-item" to="/" end onClick={closeSidebar}>
                <FontAwesomeIcon className="i" icon={faTableColumns} />
                Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink
                className="nav-item"
                to="/students"
                onClick={closeSidebar}
              >
                <FontAwesomeIcon className="i" icon={faChildren} />
                Students
              </NavLink>
            </li>
            <li>
              <NavLink
                className="nav-item"
                to="/enrollment"
                onClick={closeSidebar}
              >
                <FontAwesomeIcon className="i" icon={faAddressBook} />
                Enrollment
              </NavLink>
            </li>
            <li>
              <NavLink className="nav-item" to="/class" onClick={closeSidebar}>
                <FontAwesomeIcon className="i" icon={faChalkboardTeacher} />
                Class
              </NavLink>
            </li>
            <li>
              <NavLink className="nav-item" to="/fees" onClick={closeSidebar}>
                <FontAwesomeIcon className="i" icon={faFileInvoiceDollar} />
                Fees
              </NavLink>
            </li>
            <li>
              <NavLink
                className="nav-item"
                to="/billing"
                onClick={closeSidebar}
              >
                <FontAwesomeIcon className="i" icon={faReceipt} />
                Billing
              </NavLink>
            </li>
            <li>
              <NavLink className="nav-item" to="/users" onClick={closeSidebar}>
                <FontAwesomeIcon className="i" icon={faUsers} />
                Users
              </NavLink>
            </li>
            <li>
              <NavLink
                className="nav-item"
                to="/balancesheet"
                onClick={closeSidebar}
              >
                <FontAwesomeIcon className="i" icon={faFileInvoice} />
                Student Ledger
              </NavLink>
            </li>
            <li>
              <NavLink
                className="nav-item"
                to="/calendar"
                onClick={closeSidebar}
              >
                <FontAwesomeIcon className="i" icon={faCalendarDay} />
                Calendar
              </NavLink>
            </li>
            <li>
              <NavLink
                className="nav-item"
                to="/tiffinvehicle"
                onClick={closeSidebar}
              >
                <FontAwesomeIcon className="i" icon={faBus} />
                Tiffin & Vehicle
              </NavLink>
            </li>
            <li>
              <NavLink
                className="nav-item"
                to="/studentfees"
                onClick={closeSidebar}
              >
                <FontAwesomeIcon className="i" icon={faMoneyBill} />
                Student Fees
              </NavLink>
            </li>
            <li>
              <NavLink className="nav-item" to="/idcard">
                <FontAwesomeIcon className="i" icon={faIdCard} /> Id Cards
              </NavLink>
            </li>
          </ul>

          <div className="sidebar-footer">
            {/* <button onClick={handleBackup} className="footer-btn">
              <FontAwesomeIcon className="i" icon={faBoxArchive} />
              Backup
            </button> */}
            <button className="footer-btn logout" onClick={handleLogout}>
              <FontAwesomeIcon className="i" icon={faRightFromBracket} />
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResponsiveSidebar;
